import {getFuns, getMenu} from "@/api"
import {inputChoiceService} from "@/api/common/input-choice";
import {lang} from "@/constants/commonConstants"

export const setICList = "setICList";
export const setMenu = "setMenu";
export const setFun = "setFun";
export const refreshICList = "refreshICList";
export const refreshMenu = "refreshMenu";
export const setUser = "setUser";

const state = {
    inputChoiceDec: {},
    menu: [],
    functions: localStorage.getItem("ms_Permission"),
    user: {},
}

const getters = {
    userWorkLanguage(state) {
        let userWorkLanguage = state.user.userWorkLanguage;
        if (!!userWorkLanguage && (userWorkLanguage == 'en_US' || userWorkLanguage == 'en-US')) {
            return lang.EN;
        } else {
            return lang.CN;
        }
    },
    isSupplier(state) {
        return state.user.emplFlag == 'SUP';
    }
}

const actions = {
    [refreshICList]: function (context) {
        inputChoiceService.listInputChoice().then((res) => {
            let inputChoiceList = res.data;
            let icData = {};
            inputChoiceList.forEach((ic) => {
                if (!(icData.hasOwnProperty(ic.tableName))) {
                    icData[ic.tableName] = {};
                }
                if (!(icData[ic.tableName].hasOwnProperty(ic.fieldName))) {
                    icData[ic.tableName][ic.fieldName] = {};
                }
                icData[ic.tableName][ic.fieldName][ic.code] = {chineseValue: ic.chineseValue, seq: ic.seq, englishValue: ic.englishValue};
            });
            context.commit(setICList, icData);
        })
    },
    [refreshMenu]: function (context) {
        getMenu().then(res => {
            let menuTree = res.data.subs;
            context.commit(setMenu, menuTree);
        })
        getFuns().then(res => {
            let funs = res.data;
            context.commit(setFun, funs);
        })
    }
};

const mutations = {
    [setICList](state, icList) {
        state.inputChoiceDec = icList;
    },
    [setMenu](state, menu) {
        state.menu = menu;
    },
    [setFun](state, functions) {
        state.functions = functions;
    },
    [setUser](state, user) {
        state.user = user;
    }
}

export default {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}
